import { IconName, KebabMenuOption } from '@focaldata/cin-ui-components'
import { useContext } from 'react'
import QuestionnaireContext, {
  openImportDialog
} from '../../../../modules/Questionnaire/Questionnaire.context'
import { isFocaldataUser } from '../../../../utils/authUtils'
import { ActionsMenu } from './ActionsMenu.control'
import { useSurveyExportMenu } from './useSurveyExportMenu'

const ActionsMenuContainer = (): JSX.Element => {
  const { exportOptions, exportDialog } = useSurveyExportMenu()

  const { dispatch } = useContext(QuestionnaireContext)

  const handleOpenImportDialog = () => {
    dispatch(openImportDialog())
  }

  const actionMenuOptions: KebabMenuOption[] = [...exportOptions]

  // Import dispatches into QuestionnaireContext and needs ImportFromFileDialog
  // mounted alongside, so it stays exclusive to the questionnaire editor.
  if (isFocaldataUser()) {
    actionMenuOptions.push({
      id: 1,
      textItem: 'Import survey (.docx)',
      onClickItem: handleOpenImportDialog,
      // Not ImportQuestions: that icon has a hardcoded fill, so it neither
      // matches the others' colour nor picks up the hover state.
      iconName: IconName.CloudUploadOutlined
    })
  }

  return (
    <>
      <ActionsMenu actionMenuOptions={actionMenuOptions} />
      {exportDialog}
    </>
  )
}

export default ActionsMenuContainer
